(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("config"));
	else if(typeof define === 'function' && define.amd)
		define("hierarchy-model", ["config"], factory);
	else if(typeof exports === 'object')
		exports["hierarchy-model"] = factory(require("config"));
	else
		root["hierarchy-model"] = factory(root["config"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_13__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition